import React from "react"

export default function PendingToken() {
  return (
    <div className="flex h-full w-full items-center justify-center bg-white opacity-50">
      <div className="pi pi-spinner animate-spin text-[30px]" />
    </div>
  )
}
